import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import PFMContent from '../components/PFMContent';

const PFM = () => {
  return (
    <div className="pfm-container" style={{ backgroundColor: "#edffee" }}>
      <Header />
      <PFMContent />
      <Footer />
    </div>
  );
};

export default PFM;